import create from 'zustand';
import watchlist from 'lib/api/watchlist';
import produce from 'immer';
import { Watchlist } from '../../../../../../../../@types/watchlist';

interface IWatchlistListStore {
  isLoading: boolean;
  data: Watchlist[];
  hasNext: boolean;
  fetch: (page?: number) => Promise<void>;
}

const watchlistListStore = create<IWatchlistListStore>((set) => ({
  isLoading: false,
  data: [],
  hasNext: true,
  fetch: async (page: number) => {
    set(
      produce((state: IWatchlistListStore) => {
        if (page === 1) {
          state.data = [];
          state.hasNext = true;
        }

        state.isLoading = true;
      }),
    );
    const res = await watchlist.getAllWatchlist(null, true, page, 10);

    if (!res.data) {
      throw new Error('Error while search company data');
    }

    const { data, message, error_type, error } = res.data;

    if (error || error_type) {
      set({ isLoading: false });
      throw new Error(message);
    }

    set(
      produce((state: IWatchlistListStore) => {
        if (page === 1) {
          state.data = data;
        } else if (page > 1) {
          state.data.push(...data);
        }

        if (data.length < 10) {
          state.hasNext = false;
        }

        state.isLoading = false;
      }),
    );
  },
}));

export {
  watchlistListStore,
};
